module.exports = __webpack_public_path__ + "static/img/image.40404d05.png";